<template>
    <transition mode="out-in" :css="false" @enter="slideDown" @leave="slideUp">
        <slot></slot>
    </transition>
</template>

<script>
    import { gsap } from "gsap";
    import UX from '../../utils/ux';

    export default {
        props: {
            duration: {
                type: Number,
                default: 0.65,
            },

            scrollOnCompleted: {
                type: Boolean,
                default: true
            }
        },

        methods: {
            slideDown(el, done) {
                gsap.set(el, { height: "auto", opacity: 1 });

                gsap.from(el, {
                    duration: this.duration,
                    height: 0,
                    ease: "back.out",
                    onComplete: () => {
                        if (this.scrollOnCompleted) {
                            UX.scrollTo(this.$el, 0.5);
                        }
                        done();
                    }
                });

                gsap.from(el, {
                    duration: this.duration / 2,
                    opacity: 0,
                    delay: 0.1
                });
            },

            slideUp(el,done) {
                gsap.to(el, {
                    duration: this.duration / 2,
                    opacity: 0,
                });

                gsap.to(el, {
                    duration: this.duration,
                    display: "none",
                    height: 0,
                    margin: 0,
                    ease: "power1.out",
                    delay: 0.1,
                    onComplete: done
                });
            },
        }
    }
</script>